import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import CardLabel from './CardLabel';
import CardTagLine from './CardTagLine';

export default class UserCard extends Component {
  static propTypes = {
    full_name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    bio: PropTypes.string,
    roles: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    communityLogoPath: PropTypes.string.isRequired,
    upcomingOfficeHour: PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string,
      time: PropTypes.string,
    }),
    tags: PropTypes.array,
    company: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      member_since: PropTypes.string,
      job_title: PropTypes.string,
      url: PropTypes.string,
    }),
    job_title: PropTypes.string,
    maxTags: PropTypes.number,
    location: PropTypes.string,
    showMessageButton: PropTypes.bool,
  };

  static defaultProps = {
    bio: null,
    tags: null,
    avatar: null,
    company: {},
    job_title: null,
    upcomingOfficeHour: {},
    maxTags: 4,
    location: null,
    showMessageButton: false,
  };

  renderBio = () => {
    if (!this.props.bio) {
      return;
    }
    return (
      <div class="">
        <span>{this.props.bio}</span>
      </div>
    );
  };

  renderCompanyDescription = () => {
    if (!this.props.company.description) {
      return;
    }
    return (
      <div>
        <hr />
        <div className="Card-headline u-mb-2">
          About&nbsp;
          <a href={this.props.company.url}>{this.props.company.name}</a>
        </div>
        <div className="Card-description Card-description-company u-flex">
          <div className="u-w-11/12">
            <div>{this.props.company.description}</div>
          </div>
          <div className="u-w-1/12">
            <div
              className="Card-footer-logo u-float-right"
              style={{ backgroundImage: `url(${this.props.communityLogoPath})` }}
            />
          </div>
        </div>
      </div>
    );
  };

  renderCompanyRelationship = () => {
    if (!this.props.company.name) {
      return;
    }
    return (
      <div>
        <span>
          {this.props.company.job_title ? `${this.props.company.job_title} at ` : 'At '}
          <a href={this.props.company.url}>{this.props.company.name}</a>
        </span>
      </div>
    );
  };

  renderUserLevelJobTitle = () => {
    if (this.props.company.name || !this.props.job_title) {
      return;
    }
    return (
      <div>
        <span>{this.props.job_title}</span>
      </div>
    );
  };

  renderLocation = () => {
    if (!this.props.location) {
      return;
    }
    return (
      <div className="Card-detailInfo-location u-flex u-items-center">
        <span className="Card-detailInfo-icon">
          <i className="Icon Icon-map-marker" />
        </span>
        {this.props.location}
      </div>
    );
  };

  renderUpcomingOfficeHour = () => {
    if (!this.props.upcomingOfficeHour.name) {
      return;
    }
    return (
      <div className="Card-description">
        <hr />
        <div className="Card-headline u-mb-2">Upcoming Office Hour</div>
        <div className="UserCard-officeHour u-flex">
          <div className="u-w-3/4">
            <a href={this.props.upcomingOfficeHour.url}>
              {this.props.upcomingOfficeHour.name}&nbsp;&nbsp;•&nbsp;&nbsp;
              {this.props.upcomingOfficeHour.time}
            </a>
          </div>
          <div className="u-w-1/4">
            <a
              href={this.props.upcomingOfficeHour.url}
              className="Button Button-secondary Button--xsmall Button-radius u-float-right">
              Register to attend
            </a>
          </div>
        </div>
      </div>
    );
  };

  renderMessageButton = () => {
    if (!this.props.showMessageButton) {
      return;
    }

    let slug = this.props.slug;

    if (!this.props.slug) {
      slug = this.props.url.split('users/')[1];
    }

    return (
      <button
        className="u-text-grey u-text-sm u-ml-2 u-bg-grey-lighter u-px-2 u-py-0 u-rounded u-rounded-full"
        data-connection={slug}>
        <i className="Icon Icon-envelope u-m-0 u-align-middle" />
      </button>
    );
  };

  render() {
    return (
      <div
        className="Card-v2 Card-v2-padding"
        data-card-type="User"
        data-card-title={this.props.full_name}>
        <div className="u-flex u-items-stretch">
          <Avatar
            src={this.props.avatar}
            href={this.props.url}
            name={this.props.full_name}
            type="user"
            className="u-w-16 md:u-w-36 u-h-16 md:u-h-36 u-text-4xl u-rounded Avatar--thin-initials"
          />
          <div className="u-flex-1 u-flex u-flex-col u-pl-4 md:u-pl-6">
            <div className="u-flex-1">
              <h5 className="u-text-lg u-m-0 u-leading-none">
                <a href={this.props.url}>{this.props.full_name}</a>
                {this.renderMessageButton()}
              </h5>
              <div className="u-text-grey u-text-sm u-mt-1 u-leading-normal">
                {this.renderCompanyRelationship()}
                {this.renderUserLevelJobTitle()}
                {this.props.roles}
              </div>
              <div className="u-mt-1 u-mb-2">{this.renderBio()}</div>
            </div>
            <div className="u-flex-grow-0 md:u-block">
              {this.props.tags.length > 0 && (
                <CardTagLine
                  className="u-mt-2 md:u-mt-5"
                  seeMoreURL={this.props.url}
                  tags={this.props.tags}
                  maxTags={this.props.maxTags}
                  keyIdentifier={this.props.full_name}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
